export class OrderClaimFilter {
    
    constructor(retailerMode?: boolean, dateFrom?: Date, dateTo?: Date, cancellationPending?: boolean, cancelled?: boolean) {
        
        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
        this.retailerMode = retailerMode;
        this.cancellationPending = cancellationPending;
        this.cancelled = cancelled;
    }

    cancellationPending?: boolean;
    cancelled?: boolean;
    dateFrom?: Date
    dateTo?: Date;
    retailerMode?: boolean;
}